module.exports = __webpack_public_path__ + "img/dj.0c386d22.svg";